/** @class ItemPermissionsStatus
 *
 * @desc
 * Displays the status of the item permissions for an everplan.
 *
 */

import PropTypes from 'prop-types'

const statusText = props => {
  if (props.hasPendingRequestItemPermissionsInvite)
    return 'Your request to edit this Everplan is pending customer approval.'
  else if (props.allUsersDeceased || !props.writeAccess || !props.hasEditPermissions)
    return 'You cannot edit this Everplan.'
  else if (props.hasPartialEditPermissions)
    return 'You can edit parts of this Everplan.'
  else
    return 'You can edit this Everplan.'
}

const ItemPermissionsStatus = props => (
  <span className='prompt item-permissions-status'>{statusText(props)}</span>
)


ItemPermissionsStatus.propTypes = {
  allUsersDeceased: PropTypes.bool,
  writeAccess: PropTypes.bool,
  hasPendingRequestItemPermissionsInvite: PropTypes.bool,
  hasEditPermissions: PropTypes.bool,
  // True when the firm has *some* edit permissions on this client but not the full
  // metadata-item universe. This drives the "You can edit parts of this Everplan."
  // copy added per TK-2158.
  hasPartialEditPermissions: PropTypes.bool
}

export default ItemPermissionsStatus
